export default __webpack_public_path__ + "static/media/9.8617df44.png";